import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { setAuth } from './helpers';
import config from '~/config';
import AuthApi from '~/api/auth';

export const requestInterceptor = (config: AxiosRequestConfig) => {
  setAuth(config);
  return config;
};

export const responseInterceptor = (response: AxiosResponse) => response;

export const errorInterceptor = (error: any) => {
  // Don't handle 401 here - let axios-auth-refresh handle it
  if (error?.response?.status === 401) {
    return Promise.reject(error);
  }

  // eslint-disable-next-line no-throw-literal
  throw {
    status: error?.response?.status,
    message: error?.response?.data?.error,
  };
};

// Refresh token logic for axios-auth-refresh
// Server reads refresh token from HTTP-only cookie, no body needed
export const refreshAuthLogic = async (_failedRequest: any) => {
  try {
    await AuthApi.refreshToken();
    return Promise.resolve();
  } catch (error: any) {
    const status = error?.response?.status ?? error?.status;
    if (status === 401) {
      await performLogout();
    }
    return Promise.reject(error);
  }
};

const performLogout = async () => {
  const returnUrl = encodeURIComponent(window.location.origin + '/login');
  window.location.href = `${config.appUrl}/sso?returnUrl=${returnUrl}`;
};
